<template>
  <div v-if="vm">
    <template v-for="(item, index) in vm.form.midConsiderPeoples">
      <el-form-item
        v-if="item.type === 'AUTHOR_APPOINT'"
        :key="'mid-' + index"
        class="ellipsis-label"
        :prop="`midConsiderPeoples.${index}.peoples`"
        :rules="{
          required: true,
          message: '请选择审批人',
          trigger: 'change',
          validator: (rule, value, callback) =>
            vm.peoplesValidator(rule, value, callback),
        }"
      >
        <template slot="label">
          <el-tooltip :content="item.name" placement="top-start">
            <span>
              {{ item.name }}
            </span>
          </el-tooltip>
        </template>
        <work-order-user-select-v2
          v-if="vm.allUserOptions && vm.allUserOptions.length"
          v-model="item.peoples"
          :allOptions="vm.allUserOptions"
          size="mini"
          :disabledNullBeisen="true"
          :multiple-limit="1"
        >
        </work-order-user-select-v2>
      </el-form-item>
    </template>

    <template v-for="(item, index) in vm.qaTypeTemplateOptions">
      <el-form-item
        :label="vm.showLabel(item.moduleName)"
        :prop="vm.showPropRule(item.moduleName)"
        :rules="vm.checkPropRule(item)"
      >
        <div v-if="item.moduleName === 'WORK_ORDER_TOPIC'">
          <el-input
            v-model.trim="vm.form.wkOrderTopic"
            maxlength="50"
            show-word-limit
          ></el-input>
        </div>
        <div v-if="item.moduleName === 'WORK_ORDER_DESCRIBE'">
          <el-input
            v-model="vm.form.remark"
            type="textarea"
            show-word-limit
            maxlength="1000"
            :autosize="{ minRows: 6 }"
          ></el-input>
          <p style="color: #ff0000">{{ vm.qaTypePrompt }}</p>
        </div>
        <div v-if="item.moduleName === 'IMAGE_UPLOAD'">
          <work-order-image-upload
            :list.sync="vm.form.attachments"
          ></work-order-image-upload>
        </div>
        <div v-if="item.moduleName === 'ATTACHMENTS_UPLOAD'">
          <work-order-file-upload
            :list.sync="vm.form.attachments"
            @uploadLoading="
              (val) => {
                vm.uploadLoading = val;
              }
            "
          ></work-order-file-upload>
        </div>
        <div v-if="item.moduleName === 'PRIORITY'">
          <el-radio-group v-model="vm.form.priority">
            <el-tooltip content="72小时内处理">
              <el-radio label="NORMAL"> 一般 </el-radio>
            </el-tooltip>
            <el-tooltip content="24小时内处理">
              <el-radio label="IMPORTANT"> 重要 </el-radio>
            </el-tooltip>
            <el-tooltip content="12小时内处理">
              <el-radio label="SERIOUS"> 严重 </el-radio>
            </el-tooltip>
          </el-radio-group>
        </div>
        <div v-if="item.moduleName === 'RELATION_WORK_ORDER'">
          <div
            v-for="(relation, rIndex) in vm.form.relationWorkOrderIds"
            :key="relation + '-' + rIndex"
            style="position: relative; top: -10px"
          >
            <el-select
              v-model="vm.form.relationWorkOrderIds[rIndex]"
              placeholder="请输入工单编号"
              filterable
              remote
              clearable
              :remote-method="vm.remoteMethod"
              @change="vm.relationWorkOrderIdsChange"
              style="margin-top: 10px"
            >
              <el-option
                v-for="opt in vm.relationWorkOrderOptions"
                :key="opt.wkOrderId"
                :value="opt.wkOrderId"
                :label="opt.wkOrderId"
              >
                <span style="float: left">{{ opt.wkOrderId }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{
                  opt.wkOrderTopic
                }}</span>
              </el-option>
            </el-select>
            <el-button type="text" @click="vm.deleteRelationId(rIndex)"
              >删除</el-button
            >
          </div>
          <div>
            <el-button
              type="text"
              @click="
                () => {
                  vm.form.relationWorkOrderIds.push('');
                }
              "
              >新增</el-button
            >
          </div>
        </div>
        <div v-if="item.moduleName === 'CUSTOMER_INFO'" style="width: 100%">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-card
                v-for="(user, userIdx) in vm.form.customerInfoList"
                :key="userIdx"
                style="margin-bottom: 10px"
              >
                <el-form-item label="客户ID" style="margin-bottom: 10px">
                  <el-input v-model="user.customerId"></el-input>
                </el-form-item>
                <el-form-item label="客户手机号" style="margin-bottom: 10px">
                  <el-input v-model="user.customerPhone"></el-input>
                </el-form-item>
                <el-form-item label="客户备注" style="margin-bottom: 10px">
                  <el-input v-model="user.remark"></el-input>
                </el-form-item>
                <el-form-item label=" ">
                  <div style="display: flex; justify-content: flex-end">
                    <el-button
                      style="margin-left: auto"
                      size="small"
                      @click="vm.deleteUser(userIdx)"
                      >删除
                    </el-button>
                  </div>
                </el-form-item>
              </el-card>
            </el-col>
            <el-col :span="6">
              <el-button
                size="small"
                :disabled="vm.form.customerInfoList.length >= 1"
                @click="vm.addUserInfo"
                >添加客户信息
              </el-button>
            </el-col>
          </el-row>
        </div>
        <div v-if="item.moduleName === 'ATTENTION_USER'">
          <work-order-user-select-v2
            v-model="vm.form.newFollowPeoples"
            :allOptions="vm.allUserOptions"
            style="width: 80%"
            :disabled="!vm.enableEditAttentionUser"
            :disabledOptions="
              vm.form.builtIntoFollowPeoples.map((u) => u.userId)
            "
            disabledOptionsRemark="内置关注人"
            @input="vm.onFollowPeoplesChange"
          ></work-order-user-select-v2>
          <el-checkbox
            style="margin-left: 10px"
            v-model="vm.form.needNotifyFollowPeople"
            :disabled="vm.form.newFollowPeoples.length == 0"
          >
            <el-tooltip class="item" effect="dark" placement="top-start">
              <div slot="content">
                勾选此选项，新增关注人将会收到通知。
                <br />（内置关注人是否通知由对应类型的相关配置决定）
              </div>
              <i class="el-icon-question"></i>
            </el-tooltip>
            通知关注人
          </el-checkbox>
        </div>
        <div v-if="item.moduleName === 'WEBSITE_INFO'">
          <el-card>
            <el-form-item label="网站名称" style="margin-bottom: 10px">
              <el-input v-model="vm.form.webInfo.websiteName"></el-input>
            </el-form-item>
            <el-form-item label="网址">
              <el-input v-model="vm.form.webInfo.websiteUrl"></el-input>
            </el-form-item>
          </el-card>
        </div>
        <div v-if="item.moduleName === 'COMPANY_MODEL'">
          <el-input
            v-model.trim="vm.form.companyInfo.companyInfo"
            maxlength="100"
            show-word-limit
          ></el-input>
        </div>
        <div v-if="item.moduleName === 'MONEY_MODEL'">
          <el-input-number
            v-model.trim="vm.form.money"
            :max="999999999"
            controls-position="right"
            :precision="2"
          ></el-input-number>
        </div>
        <div v-if="item.moduleName === 'LABEL_MODEL'">
          <el-form-item
            v-for="tagItem in vm.tagOptions"
            :key="tagItem.id"
            :label="`${tagItem.labelGroupName}(${
              tagItem.pattern === 'RADIO' ? '单选' : '多选'
            })`"
            label-width="150"
          >
            <el-button
              v-for="(tag, tIndex) in tagItem.labelName"
              :key="tIndex"
              :type="vm.showTag(tagItem.id, tag)"
              round
              size="small"
              :disabled="vm.loading"
              @click="vm.handleClick(tagItem, tag, tagItem.pattern)"
            >
              {{ tag }}
            </el-button>
          </el-form-item>
        </div>

        <div v-if="item.moduleName === 'DOCTOR_INFO'">
          <el-card>
            <el-form label-width="125px">
              <el-form-item label="医生姓名" style="margin-bottom: 10px">
                <el-input
                  v-model="vm.form.doctorInfo.doctorName"
                  maxlength="50"
                ></el-input>
              </el-form-item>
              <el-form-item label="医生执业资格证">
                <el-input
                  v-model="vm.form.doctorInfo.practiceCertificate"
                  maxlength="50"
                ></el-input>
              </el-form-item>
            </el-form>
          </el-card>
        </div>

        <div v-if="item.moduleName === 'REGIONAL'">
          <select-tree
            v-model="vm.regionalSelectValue"
            @change="vm.regionalChange"
            :tree-data="vm.areaTree"
            select-mode="last"
            :filterable="true"
            :clearable="false"
            :props="{ label: 'areaName', value: 'areaId' }"
          ></select-tree>
        </div>
        <div v-if="item.moduleName === 'ACCURATE_PROJECT_INFO'">
          <el-select
            v-model="vm.accurateProjectInfoSelectValue"
            placeholder="请选择关联项目信息"
            style="width: 100%"
            :disabled="vm.projectLoading"
            filterable
            clearable
            @change="vm.onAccurateProjectChange"
          >
            <el-option
              v-for="project in vm.projectTree"
              :key="project.id"
              :label="project.name"
              :value="project.id"
              :disabled="project.disabled"
            >
              <span>{{ project.name }}</span>
              <span
                class="project-status"
                :class="project.disabled ? 'is-disabled' : 'is-enabled'"
              >
                {{ project.disabled ? "禁用" : "启用" }}
              </span>
            </el-option>
          </el-select>
        </div>
        <div v-if="item.moduleName === 'ACCURATE_CUSTOMER_INFO'">
          <el-input
            style="margin-bottom: 10px"
            v-model="vm.form.accurateCustomerInfo.customerId"
            maxlength="50"
            placeholder="请输入用户ID"
          ></el-input>
          <el-input
            v-model="vm.form.accurateCustomerInfo.customerPhone"
            maxlength="50"
            placeholder="请输入手机号"
          ></el-input>
        </div>
        <div v-if="item.moduleName === 'ACCURATE_COMPANY_MODEL'">
          <el-select
            v-model="vm.accurateCompanyInfoSelectValue"
            placeholder="请输入机构名称"
            style="width: 100%"
            filterable
            remote
            clearable
            :remote-method="vm.remoteCompanySearch"
            :loading="vm.companyLoading"
            @change="vm.onAccurateCompanyChange"
          >
            <el-option
              v-for="c in vm.companyList"
              :key="c.hospitalId"
              :label="c.hospitalName"
              :value="c.hospitalId"
            ></el-option>
          </el-select>
        </div>
        <div v-if="item.moduleName === 'BUSINESS_TYPE'">
          <el-radio-group v-model="vm.form.businessType">
            <el-radio label="REFERRAL">转诊业务</el-radio>
            <el-radio label="HAIR_TRANSPLANT">植发业务</el-radio>
            <el-radio label="ORAL_CAVITY">口腔业务</el-radio>
          </el-radio-group>
        </div>
      </el-form-item>
    </template>
  </div>
</template>

<script>
import selectTree from "@/components/selectTree.vue";

export default {
  name: "WorkSubmitFormNormalModules",
  components: {
    selectTree,
  },
  inject: {
    workSubmit: {
      default: null,
    },
  },
  computed: {
    vm() {
      return this.workSubmit;
    },
  },
};
</script>

<style lang="less" scoped>
.ellipsis-label {
  /deep/ .el-form-item__label {
    display: inline-block;
    max-width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    cursor: pointer;
  }
}

.project-status {
  display: inline-block;
  margin-left: 8px;
  padding: 0 6px;
  border-radius: 8px;
  font-size: 12px;
  line-height: 18px;
  white-space: nowrap;

  &.is-enabled {
    color: #0b6b47;
    background-color: #e8f6f0;
  }

  &.is-disabled {
    color: #606266;
    background-color: #f2f3f5;
  }
}
</style>
